<template>
  <div class="col-xs-12 col-md-6">
    <form-group-search-select
      v-if="disciplinas"
      ref="input"
      :label="label"
      :readonly="readonly"
      :value="value"
      :name="name"
      :options="disciplinas"
      :data-vv-as="label"
      :placeholder="placeholder"
      @input="$emit('input', $event)"
      @change="$emit('input', $event)"
      v-validate="{ required: required }"
    />
  </div>
</template>

<script>
import CursoService from "../../../../domain/corpore/CursoService";
import SwalMessage from "../../../../domain/message/SwalMessage";

export default {
  name: "c-protocolo-disciplina",
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator", "formValues"],
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean,
    login: {
      type: String,
      default: ""
    }
  },
  mounted() {
    this.$el.value = this.value;
  },
  computed: {
    usuario() {
      return this.$store.state.usuario;
    }
  },
  asyncComputed: {
    disciplinas() {
      let curso = this.formValues.cursoId;
      if (curso) {;
        let ra = this.login != "" ? this.login : this.usuario.login;
        const cursoService = new CursoService(this.$http);
        return cursoService
          .getDisciplinasCurso(curso, null, ra)
          .then(result => {
            return result.map(disciplina => ({
              value: disciplina.CODDISC,
              text: disciplina.NOME
            }));
          })
          .catch(err => {
            SwalMessage.warningMessage(`<p>${err.message}</p>`, "Ops!");
          });
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/Disciplina.vue